import React from "react";

import "aframe";
import "aframe-particle-system-component";
import "aframe-mouse-cursor-component";
import { Entity, Scene } from "aframe-react";

class ThreeScene extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTouchScreen: false,
      zoom: 80,
      zoomValue: 0,
      isCollapsed: false,
      currentImage: "",
      currentSelectedtourIndex: 0,
      rerender: false,
    };
    this.handleWheel = this.handleWheel.bind(this);
    this.sceneRef = React.createRef()
  }

  componentDidMount() {
    window.addEventListener("wheel", this.handleWheel, { passive: false });
    this.props.onPauseMainEngine?.();
  }

  componentWillUnmount() {
    window.removeEventListener("wheel", this.handleWheel);

    const sceneEl = this.sceneRef.current?.el; // .el = <a-scene>
    if (sceneEl) {
      try {
        // 1) Pausar el loop de A-Frame
        sceneEl.pause?.();

        // 2) Liberar geometrías / materiales / texturas del scene.object3D
        const disposeMaterial = (mat) => {
          if (!mat) return;
          // Descarta texturas referenciadas en el material
          for (const k in mat) {
            const v = mat[k];
            if (v && v.isTexture) {
              v.dispose?.();
            }
          }
          mat.dispose?.();
        };

        const disposeObject3D = (root) => {
          root.traverse((node) => {
            // geometría
            node.geometry?.dispose?.();
            // material o array de materiales
            const m = node.material;
            if (Array.isArray(m)) m.forEach(disposeMaterial);
            else disposeMaterial(m);
          });
        };

        disposeObject3D(sceneEl.object3D);

        // 3) Disponer renderer de Three.js y perder el contexto WebGL
        const renderer = sceneEl.renderer;
        renderer?.dispose?.();

        const gl = renderer?.getContext?.();
        gl?.getExtension?.("WEBGL_lose_context")?.loseContext?.();
        console.log("recursos de a-frame desmontados correctamente");
      } catch {
        console.error("No se pudo liberar los recursos de a-frame completamente :(");
      }
    }
    this.props.onResumeMainEngine?.();
  }

  /* handleWheel(e) {
    e.preventDefault();
    this.setState(prevState => {
      let newZoom = prevState.zoom + (e.deltaY > 0 ? 2 : -2); // mover zoom
      newZoom = Math.max(30, Math.min(100, newZoom)); // limitar entre 30 y 100
      return { zoom: newZoom };
    });
  } */

  handleWheel(e) {
    const sceneEl = document.querySelector("a-scene");

    // Solo bloquea si el scroll ocurre dentro del canvas de A-Frame
    if (sceneEl && sceneEl.contains(e.target)) {
      e.preventDefault();
      /* lógica de zoom si quieres */

      this.setState((prevState) => {
        let newZoom = prevState.zoom + (e.deltaY > 0 ? 2 : -2); // mover zoom
        newZoom = Math.max(30, Math.min(100, newZoom)); // limitar entre 30 y 100
        return { zoom: newZoom };
      });
    }
  }

  render() {
    return (
      <Scene
        ref={this.sceneRef}
        cursor="rayOrigin: mouse, fuse: false"
        raycaster="objects: .raycastable"
        vr-mode-ui="enabled: false"
        embedded
      >
        <a-assets>
          <a-mixin
            id="picture"
            geometry="primitive: box"
            material="side: double; color: white"
          ></a-mixin>
          <img id="thumb1" crossorigin src={this.props.selectedFile} alt="" />
        </a-assets>
        <Entity ref={this.camera}>
          {!this.state.isTouchScreen ? (
            <a-camera
              id="camera"
              fov={this.state.zoom}
              wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"
              look-controls="reverseMouseDrag: true, reverseTouchDrag: true"
              aframe-injected=""
              data-aframe-inspector-original-camera=""
              vr-mode-ui="enabled: false"
            />
          ) : (
            <a-camera
              id="camera"
              fov={this.state.zoom}
              wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"
              tocuh-look-controls="reverseMouseDrag: true, reverseTouchDrag: true"
              aframe-injected=""
              data-aframe-inspector-original-camera=""
              vr-mode-ui="enabled: false"
            />
          )}
        </Entity>
        <Entity
          primitive="a-sky"
          src={this.props.selectedFile}
          segments-height={100}
          segments-width={200}
          radius={200}
          crossorigin
        />
      </Scene>
    );
  }
}

export default ThreeScene;
